import { useEffect, useRef } from 'react';

/**
 * Hook para manejar de forma segura el desmontaje de componentes
 * durante operaciones asíncronas
 */
export function useSafeMounted() {
    const mounted = useRef(true);
    
    useEffect(() => {
        mounted.current = true;
        return () => {
        mounted.current = false;
        };
    }, []);
    
    return mounted;
}